import { useMemo } from 'react'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import { formatReturnFlightsGuestLabel } from 'lib/offer/occupancyUtils'
import { useIntl } from 'react-intl'

interface Props {
  rooms: Array<App.Occupants>
  size?: 'small' | 'medium' | 'large'
  isHighlighted?: boolean
}

function FlashHotelReturnFlightsInclusion(props: Props) {
  const {
    rooms,
    size = 'medium',
    isHighlighted = true,
  } = props
  const intl = useIntl()

  const inclusion = useMemo<App.PackageInclusion>(() => ({
    id: 'return-flights-inclusion',
    description: intl.formatMessage(
      {
        id: 'mXDPkuZjxmPWqEv75K09',
        defaultMessage: 'Return flights for {guestCountLabel}',
        description: 'Inclusion shown on a hotel rate tile when flights are toggled on',
      },
      { guestCountLabel: formatReturnFlightsGuestLabel(rooms) },
    ),
    symbol: 'plane_with_arrows',
  }), [intl, rooms])

  return <OfferInclusionItem inclusion={inclusion} isHighlighted={isHighlighted} size={size} />
}

export default FlashHotelReturnFlightsInclusion
